<template>
  <div>
  <base-table-box>
    <base-table
      class="custom-table"
      :columns="columns"
      :dataSource="tableData"
      :pagination="page"
      :rowKey="record => record.mienId"
      :loading="loading"
      @change="handleTableChange"
    >
      <template slot="mediaUrl" slot-scope="record">
        <div class="table_name_info">
          <img class="table_name_img"
               :src="imageUrl + record.mediaUrl"
               alt="">
        </div>
      </template>
      <template #content="content">
        <a-tooltip :title="content">
          <div class="table-ellipsis">
            {{content}}
          </div>
        </a-tooltip>
      </template>
      <template #operation="record">
        <a href="javascript: void 0;" class="text-btn" @click="seeRecord(record)">查看</a>
        <a href="javascript: void 0;" class="text-btn" @click="delRecord(record)">删除</a>
      </template>
    </base-table>
  </base-table-box>
  <a-modal
    title="企业动态"
    :visible="visible"
    destroyOnClose
    cancelText="关闭"
    :okButtonProps="{
      style:{
         display: 'none'
      }
    }"
    width="800px"
    :maskClosable="false"
    @cancel="cancel()"
  >
    <a-spin :spinning="loading">
      <a-form>
        <a-form-item label="标题" v-bind="formItemLayout">
          <a-input readOnly :value="mein.titleName"
          />
        </a-form-item>
        <a-form-item label="详情" v-bind="formItemLayout">
          <div ref="editor"></div>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
  </div>
</template>

<script>
import { company, common } from '@/api'
import E from 'wangeditor'
export default {
  name: 'CompanyHonor',
  beforeCreate () {
    this.formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 15 }
    }
    this.columns = [
      {
        title: '标题',
        width: 120,
        dataIndex: 'titleName'
      },
      {
        title: '发布人',
        dataIndex: 'mienUser'
      },
      {
        title: '发布账号',
        dataIndex: 'mienLoginUser'
      },
      {
        title: '发布企业',
        dataIndex: 'companyName'
      },
      {
        title: '发布时间',
        dataIndex: 'createTime'
      },
      {
        title: '操作',
        scopedSlots: {
          customRender: 'operation'
        }
      }
    ]
  },
  async mounted () {
    if (this.$route.params.id) {
      this.companyId = this.$route.params.id
    }
    await this.getTableData()
  },

  data () {
    return {
      imageUrl: process.env.VUE_APP_IMG,
      loading: false,
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      tableData: [],
      companyId: '',
      visible: false,
      mein: {},
      content: ''
    }
  },

  methods: {
    async getTableData () {
      this.loading = true
      let { code, msg, data, page } = await company.getCompanyHonorPage({
        companyId: this.companyId,
        type: '3',
        ...this.page
      })
      this.tableData = data
      this.loading = false
      if (code !== 0) return this.$message.error(msg || '数据获取失败')
      this.page.total = page.total
    },
    handleScreenSubmit () {
      this.page.current = 1
      this.getTableData()
    },
    handleReset () {
      this.screenForm.resetFields()
      this.page.current = 1
      this.getTableData()
    },
    handleTableChange ({ current }) {
      this.page.current = current
      this.getTableData()
    },
    delRecord ({ mienId }) {
      this.$confirm({
        title: '提示',
        content: '您确定要删除该荣誉信息吗?',
        okText: '确认',
        cancelText: '取消',
        onOk: async () => {
          let { code, msg } = await company.deleteCompanyHonor({
            mienId
          })
          if (code === 0) {
            this.$message.success('删除成功')
            this.getTableData()
          } else {
            this.$message.error(msg || '删除失败，请重试')
          }
        },
        onCancel () {}
      })
    },
    async seeRecord (record) {
      this.mein = record
      this.content = record.content
      this.visible = true
      await this.$nextTick()
      console.log(this.$refs.editor)
      await this.editorInit()
    },
    cancel () {
      this.mein = {}
      this.content = ''
      this.visible = false
    },
    editorInit () {
      console.log(this.$refs.editor)
      let editor = new E(this.$refs.editor)
      editor.customConfig = {
        onchange: html => {
          this.content = html
        },
        uploadImgServer: `${process.env.VUE_APP_API}${common.uploadSingle}`, // 上传图片到服务器
        uploadFileName: 'file', // 后端使用这个字段获取图片信息
        uploadImgMaxLength: 1, // 限制一次最多上传 1 张图片
        uploadImgMaxSize: 3 * 1024 * 1024,
        uploadImgTimeout: 50000
      }
      editor.customConfig.uploadImgHooks = {
        before: function (xhr, editor, files) {
          let formdata = new FormData()
          formdata.append('file', files)
        },
        customInsert: function (insertImg, result, editor) {
          insertImg(process.env.VUE_APP_IMG + result.data)
        }
      }
      editor.create()
      if (this.content) {
        editor.txt.html(this.content)
      }
      // 禁用编辑功能
      editor.$textElem.attr('contenteditable', false)
    }
  }
}
</script>

<style lang="less" scoped>
.table_name_info {
  display: flex;
  align-items: center;
  .table_name_img {
    flex: none;
    width: 60px;
    height: 60px;
    margin: 0px 12px 10px 0;
  }
}
  /deep/ .w-e-toolbar {
    flex-wrap: wrap;
  }
</style>
